import { useContext, useMemo, useRef, useState } from "react";

//context
import { ActivityFeedContext } from "@/context/ActivityFeedContext";

//interfaces
import { ICheckboxMenu } from "@/components/elements/global/dropdown/DropdownCheckboxMenu";
import { filterTypes } from "@/interfaces/activityFeed";

//hooks
import { useClickAwayClose } from "@/components/hooks/utility/useClickAwayClose";



const useFeedFilters = () => {
    const { filterDates, setFilterDates, apps, selectedFilters, selectedWorkspaces, setSelectedFilters, setSelectedWorkspaces } = useContext(ActivityFeedContext);

    //filterNotifications and filterworkspaces is based off the context values,
    //using usememo solves the issue where one instance of the checkbox list is behind another
    //and ensures that all instances of the menus are based of one source of truth that gets updated when togglefilters is called
    const filterNotifications: ICheckboxMenu = 
        useMemo(() => ({
            infoTitle: "Show Only",
            items: filterTypes.map(type => ({
            text: type,
            value: type,
            checked: selectedFilters.includes(type),
            disabled: false,
            onChange: () => toggleFilters(type, "Show Only"),
        })),
    }), [selectedFilters]);

    const filterWorkspaces: ICheckboxMenu = 
        useMemo(() => ({
            infoTitle: "Workspaces",
            items: apps.map(({ id, name }) => ({
            key: id,
            text: name,
            value: id,
            checked: selectedWorkspaces.includes(id),
            disabled: false,
            onChange: () => toggleFilters(id.toString(), "Workspaces"),
        })),
    }), [apps, selectedWorkspaces]);

    //pop out and fullpage filter variables
    const popoutClassname = "pop-out-notification-filters";
    const dropdownContainerRef = useRef<any>()
    const [showDropdown, setShowDropdown] = useState<boolean>(false);
    const filterButtonLabel = 'Filter the Editor Activity Feed';
    const filterButtonClassname = 'filter-button';

    useClickAwayClose(showDropdown, dropdownContainerRef, () => setShowDropdown(false));

    function onClickFilterButton(){
        setShowDropdown(!showDropdown)
    }

    function toggleFilters(filter: string, category: "Workspaces" | "Show Only") {
        if (category === "Workspaces") {
            const id = Number(filter);
            const isWorkspaceSelected = selectedWorkspaces.includes(id);
            const newSelectedWorkspaces = isWorkspaceSelected 
                ? selectedWorkspaces.filter(sWorkspace => sWorkspace !== id)
                : [...selectedWorkspaces, id];

            setSelectedWorkspaces(newSelectedWorkspaces);
        } else {
            const isFilterAlreadySelected = selectedFilters.includes(filter);
            const newSelectedFilters = isFilterAlreadySelected 
                ? selectedFilters.filter(sFilter => sFilter !== filter) 
                : [...selectedFilters, filter];

            setSelectedFilters(newSelectedFilters);
        }
    };

    return {
        filterWorkspaces,
        filterNotifications,
        filterDates,
        setFilterDates,
        feedFilters: apps.length > 1
        ? [filterNotifications, filterWorkspaces]
        : [filterNotifications],
        popoutClassname,
        dropdownContainerRef,
        showDropdown,
        filterButtonLabel,
        filterButtonClassname,
        onClickFilterButton,
        filterCount: selectedFilters.length + selectedWorkspaces.length
    };
};

export default useFeedFilters;